module.exports = __webpack_public_path__ + "static/media/starsys_logo.dba2c270.svg";